import { object, string } from "yup";

export const admissionSchema = object().shape({
  admissionIsValidated: string().optional(),
  trialContractTerm: string()
    .required("Prazo do contrato de experiência é obrigatório")
    .oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para o prazo do contrato"),
  trialContractTermFirst: string().when("trialContractTerm", {
    is: "5",
    then: string().required("Informe a 1ª experiência"),
    otherwise: string().optional().nullable(),
  }),
  trialContractTermSecond: string().when("trialContractTermFirst", {
    is: (firstVal) => {
      const num = parseInt(firstVal, 10) || 0;
      return num > 0 && num < 90;
    },
    then: string().required("Informe a 2ª experiência"),
    otherwise: string().optional().nullable(),
  }),
  hasSpecificRegistrationRules: string()
    .required("Regra específica para o cadastro de matrículas é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para regra de matrículas"),
  specificRegistrationRulesDescription: string().when(
    "hasSpecificRegistrationRules",
    {
      is: "1",
      then: string().required("Descreva a regra de negócio para as matrículas"),
      otherwise: string().optional().nullable(),
    },
  ),
  useSamePayrollRegistrationForTimeTracking: string()
    .required("Utilização de matrícula no ponto é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para utilização de matrícula"),
  workTimeControl: string()
    .required("Controle de jornada é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para controle de jornada"),
  timeTrackingClosePeriod: string()
    .required("Período de fechamento do ponto é obrigatório")
    .oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para período de fechamento"),
  timeTrackingClosePeriodOther: string().when("timeTrackingClosePeriod", {
    is: "4",
    then: string()
      .required("Informe o período de fechamento")
      .matches(/^\d{2}\/\d{2}$/, "Formato inválido, use DD/DD (ex: 01/31)"),
    otherwise: string().optional().nullable(),
  }),
  hasBankOfHours: string()
    .required("Banco de horas é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para banco de horas"),
  bankOfHoursFrequency: string().when("hasBankOfHours", {
    is: "1",
    then: string().required("Informe a frequência do banco de horas"),
    otherwise: string().optional().nullable(),
  }),
});
